// @ts-strict-ignore
import React from 'react';
import styled from 'styled-components';
import { Table } from './StyledTable';
import type { ImportedScalarValue } from './types';
import WorkflowAndEvaluationCells from './WorkflowAndEvaluationCells';

type ImportedScalarValuesTableProps = {
  type: string;
  scalarValues: ImportedScalarValue[];
};

const ActionTypeIcon = styled.p`
  margin-right: 2px;
`;

const ImportedAttributeLabel = styled.p`
  padding: 5px 10px;
  width: 66%;
  background-color: #AACDE1;
  border-radius: 5px;
  align-items: baseline;
  display: inline-flex;
`;

const AttributeName = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ScalarValue = styled.p`
  margin-left: 4px;
`;

const ScalarValueCell = styled.div`
  align-items: baseline;
`;

export const iconByActionType = {
  imported_output_attribute: 'fa-sign-out',
  imported_matrix_model: 'fa-border-all',
};

const ImportedScalarValuesTable = ({
  scalarValues,
  type,
}: ImportedScalarValuesTableProps) => (
  <Table>
    <tr>
      <th>{type === 'imported_output_attribute' ? 'Output Attribute' : 'Matrix Model'}</th>
      <th>Workflow</th>
      <th>Evaluation</th>
    </tr>
    {scalarValues.map(({
      value,
      evaluation_token: evaluationToken,
      name,
      workflow_name: workflowName,
      workflow_token: workflowToken,
      workflow_version: workflowVersion,
    }) => (
      <tr key={`${type}_table_row_${name}`}>
        <td>
          <ScalarValueCell>
            <ImportedAttributeLabel>
              <ActionTypeIcon className={`far fa-fw ${iconByActionType[type]}`} />
              <AttributeName title={name}>{name}</AttributeName>
            </ImportedAttributeLabel>
            <ScalarValue className="d-inline">{value}</ScalarValue>
          </ScalarValueCell>
        </td>
        <WorkflowAndEvaluationCells
          workflowName={workflowName}
          evaluationToken={evaluationToken}
          workflowToken={workflowToken}
          workflowVersion={workflowVersion}
        />
      </tr>
    ))}
  </Table>
);

export default ImportedScalarValuesTable;
